import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref, useContext } from '@nuxtjs/composition-api'

type AbpayVariantId = 'visa' | 'wallet'

interface AbpayBullet {
  text: string
  extra?: string
}

interface AbpayVariant {
  id: AbpayVariantId
  image: string
  imageAlt: string
  title: string
  text: string
  extraText?: string
  bullets: AbpayBullet[]
  buttonText: string
  url: string
  openGoal: string
  clickGoal: string
  closeGoal: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbpayModal',
  props: {
  afterPayment: {
    type: Boolean,
    default: false
  }
},
  emits: ['callYandexMetricGoal'],
  setup(__props, { emit }) {

const props = __props




const { $cookies } = useContext()

const CLOSE_BUTTON_DELAY_MS = 3000
const VARIANT_COOKIE = 'abpay_modal_variant'
const CARD_URL = process.env.ABPAY_CARD_URL || 'https://wallet.tapper.cloud/'
// const WALLET_URL = process.env.ABPAY_WALLET_URL || ''

const variants: Partial<Record<AbpayVariantId, AbpayVariant>> = {
  visa: {
    id: 'visa',
    image: require('@shared/assets/abpay/abpay-visa.png'),
    imageAlt: 'Карта Tapper VISA',
    title: 'Выпустите карту VISA за 3 минуты',
    text: 'Одна карта для зарубежных платежей: пополняйте рублями и пользуйтесь<br>по всему миру',
    bullets: [
      {
        text: 'Оплачивайте зарубежные сервисы',
        extra: '— ChatGPT, Steam, Netflix и др.'
      },
      { text: 'Платите за границей с выгодной конвертацией' },
      { text: 'Переводите деньги на зарубежные счета' }
    ],
    buttonText: 'Оформить карту',
    url: CARD_URL,
    openGoal: 'visa_banner_show',
    clickGoal: 'visa_banner_click',
    closeGoal: 'visa_banner_close'
  }
  // wallet: {
  //   id: 'wallet',
  //   image: require('@shared/assets/abpay/tapper-crypto.png'),
  //   imageAlt: 'USDT в кошельке Tapper',
  //   title: 'USDT без лимитов в кошельке Tapper',
  //   text: 'Отправляйте и принимайте USDT — без ограничений и лимитов',
  //   extraText: 'Меняйте USDT на рубли с оплатой через СБП',
  //   bullets: [],
  //   buttonText: 'Открыть кошелёк',
  //   url: WALLET_URL,
  //   openGoal: 'abpay_wallet_open',
  //   clickGoal: 'abpay_wallet_click',
  //   closeGoal: 'abpay_wallet_close'
  // }
}

const showModal = ref<boolean>(false)
const showCloseBtn = ref<boolean>(false)
const variantId = ref<AbpayVariantId>('visa')
let closeBtnTimeout: ReturnType<typeof setTimeout> | null = null

const currentVariant = computed(() => variants[variantId.value] || variants.visa as AbpayVariant)

const metricGoals = computed(() => {
  if (props.afterPayment) {
    return {
      open: 'visa_banner_show_after_payment',
      click: 'visa_banner_click_after_payment',
      close: 'visa_banner_close_after_payment'
    }
  }

  return {
    open: currentVariant.value.openGoal,
    click: currentVariant.value.clickGoal,
    close: currentVariant.value.closeGoal
  }
})

function getNextVariantId (): AbpayVariantId {
  // Пока показываем только карту VISA
  return 'visa'
  // const lastShown = $cookies.get(VARIANT_COOKIE)
  // return lastShown === 'visa' ? 'wallet' : 'visa'
}

function rememberVariant (id: AbpayVariantId) {
  $cookies.set(VARIANT_COOKIE, id, {
    path: '/',
    maxAge: 60 * 60 * 24 * 365
  })
}

const openOffer = () => {
  emit('callYandexMetricGoal', metricGoals.value.click)

  if (typeof window === 'undefined' || !currentVariant.value.url) {
    return
  }

  window.location.href = currentVariant.value.url
}

const closeModal = () => {
  emit('callYandexMetricGoal', metricGoals.value.close)
  showModal.value = false
  showCloseBtn.value = false

  if (closeBtnTimeout) {
    clearTimeout(closeBtnTimeout)
    closeBtnTimeout = null
  }
}

onMounted(() => {
  variantId.value = getNextVariantId()
  rememberVariant(variantId.value)
  showModal.value = true
  emit('callYandexMetricGoal', metricGoals.value.open)
  closeBtnTimeout = setTimeout(() => {
    showCloseBtn.value = true
  }, CLOSE_BUTTON_DELAY_MS)
})

onUnmounted(() => {
  if (closeBtnTimeout) {
    clearTimeout(closeBtnTimeout)
  }
})

return { __sfc: true,props, emit, $cookies, CLOSE_BUTTON_DELAY_MS, VARIANT_COOKIE, CARD_URL, variants, showModal, showCloseBtn, variantId, closeBtnTimeout, currentVariant, metricGoals, getNextVariantId, rememberVariant, openOffer, closeModal }
}

})